import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'RatingHead',
    props: {
        columnsLimit: {
            default: 0,
            type: Number,
        },
        head: {
            default: () => ({}),
            type: Object,
        },
        shouldSort: {
            default: true,
            type: Boolean,
        },
        sorting: {
            default: () => ({}),
            type: Object,
        },
        withPosition: {
            default: true,
            type: Boolean,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        function getCurrentSort(key) {
            if (key in props.sorting) {
                return props.sorting[key] ? 'ascending' : 'descending';
            }
            return '';
        }
        return {
            css,
            getCurrentSort,
        };
    },
});
